import React from 'react'
import { Grid } from '@material-ui/core'
import { Form } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import MyDatePicker from '../../../control/datepicker/datepicker'
import Button from '../../../control/button/button'
import useTranslate from '../../../i18n/useTranslate'

export type SearchForm = { keyword?: string; createdDate?: string | null }

const SearchPanel: React.FC<{
    initialValues: SearchForm
    onSubmit: (v: SearchForm) => void
    onReset: (form: any) => void
}> = ({ initialValues, onSubmit, onReset }) => {
    const t = useTranslate()

    return (
        <Form<SearchForm> onSubmit={onSubmit} initialValues={initialValues}>
            {({ handleSubmit, form }) => (
                <Grid container spacing={2} style={{ padding: 16 }}>
                    <Grid item xs={12} md={6}>
                        <MyTextfield
                            name="keyword"
                            materialInputProps={{
                                label: t.get('UM.SETTING_AGENDA.SEARCH_BY_KEYWORD'),
                                placeholder: t.get('UM.SETTING_AGENDA.SEARCH_BY_KEYWORD_PLACEHOLDER'),
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MyDatePicker name="createdDate" label={t.get('UM.SETTING_AGENDA.CREATED_DATE')} size="small" />
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container justify="flex-end" spacing={2}>
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    color="default"
                                    onClick={() => {
                                        form.reset()
                                        onReset(form)
                                    }}
                                >
                                    {t.get('BUTTON.RESET')}
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" onClick={handleSubmit}>
                                    {t.get('BUTTON.SEARCH')}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Form>
    )
}

export default SearchPanel
